import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-managepayers',
  templateUrl: './managepayers.component.html',
  styleUrls: ['./managepayers.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],

})
export class ManagepayersComponent implements OnInit {

  displayedColumns: string[] = ['payername', 'payerid', 'cpid', 'payertype'];
  dataSource = [];// new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);

  displayedColumnss: string[] = ['payernames', 'payerids', 'cpids', 'oon', 'Action'];
  dataSource1 = [] //new MatTableDataSource<PeriodicElement1>(ELEMENT_DATA1);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public show: boolean = false;

  constructor() { }

  ngOnInit() {
    //this.dataSource.paginator = this.paginator;

  }

}


